import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function SubstanceMoreNamesInformation({ onToggle, substance }) {
  const { details } = substance;
  const { chemicalNames, chemicalNameSynonyms } = details;

  const firstName = chemicalNames[0];
  const otherNames = chemicalNameSynonyms.join('; ');

  return (
    <div id="substance-supplier-information" className="substance-results-information typography-small" aria-expanded>
      <div className="sub-menu">
        <i role="button" tabIndex="0" className="sub-menu-close ss-delete" onClick={onToggle} />
        <div className="u-els-font-size-h3">
          <span>Chemical Names and Synonyms</span>
        </div>

        <InnerHTML tag="div" html={firstName} mode="escape" />
        <InnerHTML tag="div" className="rx-substance-identification" html={otherNames} mode="escape" />
      </div>
    </div>
  );
}

SubstanceMoreNamesInformation.propTypes = {
  onToggle: PropTypes.func.isRequired,
  substance: PropTypes.object.isRequired,
};

export default SubstanceMoreNamesInformation;
